import { TFunction } from "next-i18next";

const listItems = ["lead_wall_list_1", "lead_wall_list_2", "lead_wall_list_3"];

export const getTexts = (
  t: TFunction,
  isCertificate?: boolean,
  isPartner?: boolean,
) => {
  if (isCertificate) {
    return {
      title: t("lead_wall_certificate_title"),
      description: t("lead_wall_certificate_description"),
      listItems: listItems.map((item) => t(item)),
    };
  } else if (isPartner) {
    return {
      title: t("lead_wall_title"),
      description: t("lead_wall_description_partner"),
      listItems: listItems.map((item) => t(item)),
    };
  }
  return {
    title: t("lead_wall_title"),
    description: t("lead_wall_description"),
    listItems: listItems.map((item) => t(item)),
  };
};
